import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'antd';
import axios from 'axios';

const EditGroup = ({ editGroupModal, setEditGroupModal, name,id, getGroups }) => {
    const [showModal, setShowModal] = useState(false);
    const [title, setTitle] = useState(false);

    useEffect(() => {
        setTitle(name)
        console.log('edit group show modal =====>', editGroupModal)

        setShowModal(editGroupModal);
    }, [editGroupModal]);

    const handleOk = () => {
        editGroup()
        setEditGroupModal(false);
    };

    const handleCancel = () => {
        setEditGroupModal(false);
    };

    const editGroup = async () => {
        console.log({id:id,name:name})
        const request = await axios({method:'post',
        url:`${process.env.REACT_APP_WEB_API_DEV}api/v1/assessments/update-test-group`,
        data: {id:id,name:title},
        headers: {
            authorization: localStorage.getItem("jwtToken"),
            'Content-Type': 'application/json'
        },
        });

        if (request?.data?.meta?.code === 200) {
            getGroups();
        }
        // setTitle(request.data.data);
    }

    return (
        <>
            <Modal title="About Group" open={showModal} onOk={handleOk} onCancel={handleCancel}>

                    <div style={{display:"flex", alignItems:"center", width:"100%"}}>
                        <input
                        type="text" 
                        value={title}
                        onChange={(e) => { setTitle(e.target.value) }}
                        style={{width:"100%"}}></input>
                    </div>

            </Modal>
        </>
    );
};

export default EditGroup;